<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Visores</div>
      <!--<div slot="sub-title">Jinetes pertenecientes a la escuela</div>-->
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns is-multiline">
        <div v-for="(item, index) in viewers"
          :key="index"
          class="column is-6">
          <viewer-card :url="item.url" :name="item.name" :icon="item.icon"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import ViewerCard from './components/ViewerCard'
import CredentialsService from '@/services/CredentialsService.js'
import Environment from '../../environments/environment'

export default {
  components: {
    HeroBar,
    ViewerCard
  },
  data () {
    return {
      viewers: [
        { name: 'Visor Evaluaciones', icon: 'eye-outline', url: `${Environment.PASSAGE_VIEWER}/tenants/${CredentialsService.getCurrentTenantId()}/evaluations` },
        { name: 'Visor Evaluaciones por Jueces', icon: 'account-multiple', url: `${Environment.PASSAGE_VIEWER}/tenants/${CredentialsService.getCurrentTenantId()}/evaluations-judges` },
        { name: 'Visor Evaluaciones de Ejercicios', icon: 'playlist-check', url: `${Environment.PASSAGE_VIEWER}/tenants/${CredentialsService.getCurrentTenantId()}/evaluations-exercises` },
        { name: 'Visor Trabajo Diario', icon: 'calendar-account', url: `${Environment.PASSAGE_VIEWER}/tenants/${CredentialsService.getCurrentTenantId()}/daily-work` }
      ]
    }
  }
}
</script>
